module.exports = __webpack_public_path__ + "static/media/future-tense-table-1.67dd6e5f.PNG";